"use client";

import { useState, useEffect } from "react";
import "./Sidebar.css";
import Image from "next/image";
import { IoMdClose } from "react-icons/io";
import Link from "next/link";

export default function Sidebar() {
  const [openMenus, setOpenMenus] = useState({});
  const [isClient, setIsClient] = useState(false);

  const toggleMenu = (key) => {
    setOpenMenus((prev) => ({ ...prev, [key]: !prev[key], }));
  };

  useEffect(() => {
    setIsClient(true);

    import("bootstrap/dist/js/bootstrap.bundle.min.js").then((bootstrap) => {
      window.bootstrap = bootstrap;
    });
  }, []);

  const handleCloseSidebar = () => {
    const sidebarElement = document.getElementById("mobileSidebar");

    if (!sidebarElement || !window.bootstrap?.Offcanvas) return;

    const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(sidebarElement);
    if (bsOffcanvas) {
      bsOffcanvas.hide();
    }
  };

  return (
    <>
      {/* Toggle Button */}
      <button className="hamberger-button" data-bs-toggle="offcanvas" data-bs-target="#mobileSidebar" aria-controls="mobileSidebar" aria-label="toggle button">
        <span className="Css-menu-icon-span side1"></span>
        <span className="Css-menu-icon-span side2"></span>
        <span className="Css-menu-icon-span side3"></span>
      </button>

      {/* Sidebar */}
      <div className="offcanvas offcanvas-end Css-border-right" tabIndex="-1" id="mobileSidebar" aria-labelledby="mobileSidebarLabel" style={{ maxWidth: "348px", }}>
        <div className="offcanvas-header Css-logo-sidebar-header">
          <Link href="/">
            <Image
              src="https://cdn.dotplus.in/Cloud/Aarogyam/logo/HDNA_Aarogyam_Hospital_Logo.png"
              alt="HDNA Aarogyam Hospital Official Logo - High Quality"
              title="HDNA Aarogyam Hospital Official Logo - High Quality"
              className="Css-hdna-logo-sidebar"
              onClick={handleCloseSidebar}
              width={180}
              height={51}
              priority
            />
          </Link>
          <button type="button" style={{ background: "rgb(236 236 236)", lineHeight: "1px", color: '#000', position: "absolute", right: "26px", top: "22px", borderRadius: "50%", opacity: "1", }}
            className="btn-close text-reset Css-sidebar-close-icon"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <IoMdClose color="black" />
          </button>
        </div>

        <div className="offcanvas-body">
          <ul className="list-unstyled Css-sidebar-menu">
            <li> <Link href="/" className="d-block py-2 css-lr-padding" onClick={handleCloseSidebar}>Home</Link> </li>
            {/* About us Dropdown */}
            <li>
              <div
                className="d-flex justify-content-between align-items-center py-2 css-bg-black"
                onClick={() => toggleMenu("about")}
              >
                <Link href="#">About Us</Link>
                <span className="Css-style-icon-pl-mn">{openMenus["about"] ? "−" : "+"}</span>
              </div>
              <div className={`collapse ${openMenus["about"] ? "show" : ""}`}>
                <ul className="ps-3-css">
                  <li>
                    <Link href="/about-us" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                      About
                    </Link>
                  </li>
                  <li>
                    <Link href="/vision-and-mission" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                      Vision and Mission
                    </Link>
                  </li>
                </ul>
              </div>
            </li>

            {/* Department Dropdown */}
            <li>
              <div
                className="d-flex justify-content-between align-items-center py-2 css-bg-black"
                onClick={() => toggleMenu("CentersofExcellence")}
              >
                <Link href="#">Our Centers of Excellence</Link>
                <span className="Css-style-icon-pl-mn">
                  {openMenus["CentersofExcellence"] ? "−" : "+"}
                </span>
              </div>

              <div className={`collapse ${openMenus["CentersofExcellence"] ? "show" : ""}`}>
                <ul className="ps-3-css">
                  {/* Institute of Cardiac Sciences */}
                  <li>
                    <div
                      className="d-flex justify-content-between align-items-center py-1 css-nested-border"
                      onClick={() => toggleMenu("CardiacSciences")}
                    >
                      <Link href="#">Institute of Cardiac Sciences</Link>
                      <span className="Css-style-icon-pl-mn">
                        {openMenus["CardiacSciences"] ? "−" : "+"}
                      </span>
                    </div>

                    <div className={`collapse ${openMenus["CardiacSciences"] ? "show" : ""}`}>
                      <ul className="ps-3-css">
                        <li>
                          <Link href="/our-centers-of-excellence/institute-of-cardiac-sciences/interventional-cardiology" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                            Interventional Cardiology & Non Interventional Cardiology
                          </Link>
                        </li>
                        <li>
                          <Link href="/our-centers-of-excellence/institute-of-cardiac-sciences/ctvs" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                            Cardiothoracic and Vascular Surgery (CTVS)
                          </Link>
                        </li>
                        <li>
                          <Link href="/our-centers-of-excellence/institute-of-cardiac-sciences/heart-failure" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                            Heart Failure
                          </Link>
                        </li>
                        <li>
                          <Link href="/our-centers-of-excellence/institute-of-cardiac-sciences/paediatric-cardiology" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                            Paediatric Cardiology
                          </Link>
                        </li>
                        <li>
                          <Link href="/our-centers-of-excellence/institute-of-cardiac-sciences/electrophysiology-and-rfa-clinic" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                            Electrophysiology & RFA Clinic
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>

                  {/* Institute of Renal Science & Renal Transplant */}
                  <li>
                    <div
                      className="d-flex justify-content-between align-items-center py-1 css-nested-border"
                      onClick={() => toggleMenu("RenalScience")}
                    >
                      <Link href="#">Institute of Renal Science & Renal Transplant</Link>
                      <span className="Css-style-icon-pl-mn">{openMenus["RenalScience"] ? "−" : "+"}</span>
                    </div>

                    <div className={`collapse ${openMenus["RenalScience"] ? "show" : ""}`}>
                      <ul className="ps-3-css">
                        <li>
                          <Link href="/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/nephrology-care" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                            Nephrology
                          </Link>
                        </li>
                        <li>
                          <Link href="/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/pediatric-nephrology-care" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                            Pediatric Nephrology
                          </Link>
                        </li>
                        <li>
                          <Link href="/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/renal-transplant" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                            Renal Transplant
                          </Link>
                        </li>
                        <li>
                          <Link href="/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/dialysis-care" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                            Dialysis
                          </Link>
                        </li>
                        <li>
                          <Link href="/our-centers-of-excellence/institute-of-renal-science-and-renal-transplant/urology-treatment" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                            Urology & Uro Surgery
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>

                  {/* Department Of Neuro Science */}
                  <li>
                    <div
                      className="d-flex justify-content-between align-items-center py-1 css-nested-border"
                      onClick={() => toggleMenu("NeuroScience")}
                    >
                      <Link href="#">Department Of Neuro Science</Link>
                      <span className="Css-style-icon-pl-mn">
                        {openMenus["NeuroScience"] ? "−" : "+"}
                      </span>
                    </div>

                    <div className={`collapse ${openMenus["NeuroScience"] ? "show" : ""}`}>
                      <ul className="ps-3-css">
                        <li>
                          <Link href="/our-centers-of-excellence/department-of-neuro-science/neurology-care" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                            Neurology
                          </Link>
                        </li>
                        <li>
                          <Link href="/our-centers-of-excellence/department-of-neuro-science/neurosurgery-department" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                            Neurosurgery
                          </Link>
                        </li>
                        <li>
                          <Link href="/our-centers-of-excellence/department-of-neuro-science/spine-department" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>
                            Brain & Spine Surgery
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li>
                    <Link href="/our-centers-of-excellence/department-of-orthopaedics" className="d-block css-bb-1" onClick={handleCloseSidebar}>Department of Orthopedics & Joint Replacement</Link>
                  </li>
                  <li>
                    <Link href="/our-centers-of-excellence/department-of-general-surgery" className="d-block css-bb-1" onClick={handleCloseSidebar}>Department Of General Surgery</Link>
                  </li>
                  <li>
                    <Link href="/our-centers-of-excellence/department-of-anesthesia-and-critical-care" className="d-block css-bb-1" onClick={handleCloseSidebar}>Department Of Anesthesia & Critical Care</Link>
                  </li>
                  <li>
                    <Link href="/our-centers-of-excellence/department-of-internal-medicine" className="d-block css-bb-1" onClick={handleCloseSidebar}>Department Of Internal Medicine</Link>
                  </li>
                  <li>
                    <Link href="/our-centers-of-excellence/department-of-pediatrics" className="d-block css-bb-1" onClick={handleCloseSidebar}>Department of Pediatrics</Link>
                  </li>
                  <li>
                    <Link href="/our-centers-of-excellence/department-of-endocrinology" className="d-block css-bb-1" onClick={handleCloseSidebar}>Department Of Endocrinology</Link>
                  </li>
                </ul>
              </div>
            </li>
            {/* Our Facilities */}
            <li>
              <div
                className="d-flex justify-content-between align-items-center py-2 css-bg-black"
                onClick={() => toggleMenu("facilities")}
              >
                <Link href="#">Our Facilities</Link>
                <span className="Css-style-icon-pl-mn">
                  {openMenus["facilities"] ? "−" : "+"}
                </span>
              </div>
              <div className={`collapse ${openMenus["facilities"] ? "show" : ""}`}>
                <ul className="ps-3-css">
                  <li>
                    <Link href="/our-facilities/emergency-and-trauma-care" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>Emergency & Trauma Care</Link>
                  </li>
                  <li>
                    <Link href="/our-facilities/outpatient-department" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>OPD</Link>
                  </li>
                  <li>
                    <Link href="/our-facilities/hemodialysis-treatment" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>Hermodialysis 24*7</Link>
                  </li>
                  <li>
                    <Link href="/our-facilities/cath-lab" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>Cathlab</Link>
                  </li>
                  <li>
                    <Link href="/our-facilities/cardiac-icu" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>Cardiac ICU</Link>
                  </li>
                  <li>
                    <Link href="/our-facilities/medical-and-surgical-icu" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>Medical & Surgical ICU</Link>
                  </li>
                  <li>
                    <Link href="/our-facilities/renal-hdu" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>Renal HDU</Link>
                  </li>
                  <li>
                    <Link href="/our-facilities/private-and-general-wards" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>Private & General Wards</Link>
                  </li>
                  <li>
                    <Link href="/our-facilities/non-invasive-cardiac-lab" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>Non-Invasive Cardiac Lab (ECHO TMT HOLTER)</Link>
                  </li>
                  <li>
                    <Link href="/our-facilities/radiology" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>Radiology</Link>
                  </li>
                  <li>
                    <Link href="/our-facilities/pathology" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>Pathology</Link>
                  </li>
                  <li>
                    <Link href="/our-facilities/pharmacy" className="d-block css-dropdown-border" onClick={handleCloseSidebar}>Pharmacy</Link>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <Link href="/our-tie-ups-and-empanelments" className="d-block py-2 css-lr-padding" onClick={handleCloseSidebar}>Our Tie-Ups</Link>
            </li>
            <li>
              <Link href="/our-doctors" className="d-block py-2 css-lr-padding" onClick={handleCloseSidebar}> Doctors </Link>
            </li>
            <li>
              <Link href="/gallery" className="d-block py-2 css-lr-padding" onClick={handleCloseSidebar}> Gallery </Link>
            </li>
             <li>
              <Link href="/blog" className="d-block py-2 css-lr-padding" onClick={handleCloseSidebar}> Blog </Link>
            </li>
            <li>
              <Link href="/contact" className="d-block py-2 css-lr-padding" onClick={handleCloseSidebar}> Contact </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
